module.exports = __webpack_public_path__ + "assets/img/w4.2327818d.png";